module.exports = __webpack_public_path__ + "bab19bee8c9c8db6cd215f5c79a97cbb.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/793.png
// module id = 1701
// module chunks = 2